import { getFirestore } from '@firebase/firestore';
import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

const firebaseConfig = {
  apiKey: 'AIzaSyD-4m6ho2DEc253sikBQ502a90x1hVqvIQ',
  authDomain: 'flow-festival-565ce.firebaseapp.com',
  projectId: 'flow-festival-565ce',
  storageBucket: 'flow-festival-565ce.appspot.com',
  messagingSenderId: '975133334261',
  appId: '1:975133334261:web:920f8a3d669114355f43bc',
  measurementId: 'G-2GENNCJ0E9',
};

const Firebase = initializeApp(firebaseConfig);
export const auth = getAuth(Firebase);
export const db = getFirestore(Firebase);
export const googleProvider = new GoogleAuthProvider();

export default Firebase;



// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/config/firebase.ts